import React from 'react'
import StarIcon from '@material-ui/icons/Star'
import StarBorderIcon from '@material-ui/icons/StarBorder'

export const COACH_REVIEW_STAR_COLOR = '#00205B'
export const COACH_REVIEW_STAR_EMPTY_COLOR = '#A8B8CC'

export const coachReviewCardRatingIcons = {
  iconFilled: <StarIcon htmlColor={COACH_REVIEW_STAR_COLOR} />,
  iconHovered: <StarIcon htmlColor={COACH_REVIEW_STAR_COLOR} />,
  iconNormal: <StarBorderIcon htmlColor={COACH_REVIEW_STAR_EMPTY_COLOR} />,
}
